import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function FinancialConsultingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-[#F5F7FA]">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="flex items-center gap-16">
            <div className="w-[40%]">
              <div className="text-sm text-gray-500 mb-6">Главная / Услуги / Финансы</div>
              <h1 className="text-7xl font-bold text-[#0A1628] leading-tight mb-8">
                Превращаем законодательство в преимущество
              </h1>
              <p className="text-xl text-gray-600 font-light italic mb-12 leading-relaxed">
                "Вашими активами управляет команда лицензированных профессионалов: международные адвокаты, юристы, действующие аудиторы и инспекторы налогового регулирования. Гарантия полной легальности."
              </p>
              <div className="flex gap-12">
                {[
                  { value: '100%', label: 'легальность' },
                  { value: '24/7', label: 'поддержка' },
                  { value: '15 лет', label: 'опыта' }
                ].map((stat, i) => (
                  <div key={i}>
                    <div className="text-5xl font-bold text-[#D4AF37] mb-2">{stat.value}</div>
                    <div className="text-sm text-gray-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-[60%]">
              <img 
                src="https://public.readdy.ai/ai/img_res/723017c3169fb64f488353fcbaa7c09d.jpg"
                alt="Team Meeting"
                className="w-full h-[600px] object-cover object-top rounded-l-[60px] shadow-[0_40px_100px_rgba(0,0,0,0.15)]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Turkey Business Hub Timeline */}
      <section className="py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="text-center mb-20">
            <h2 className="text-6xl font-semibold text-[#0A1628] mb-6">Турция — Бизнес-хаб под ключ</h2>
            <p className="text-xl text-gray-600 font-light">Полный цикл сопровождения вашего бизнеса</p>
          </div>

          <div className="relative">
            <div className="absolute left-12 top-0 bottom-0 w-0.5 bg-[#D4AF37]"></div>

            {[
              {
                icon: 'ri-file-text-line',
                title: 'Регистрация и Старт',
                items: [
                  'Создание компании («бизнес-окно») с полным юридическим сопровождением',
                  'Открытие корпоративных счетов в турецких и международных банках',
                  'Постановка на учет в налоговых органах и получение всех необходимых лицензий',
                  'Регистрация товарных знаков и защита интеллектуальной собственности'
                ]
              },
              {
                icon: 'ri-scales-line',
                title: 'Налоги и Право',
                items: [
                  'Легальная налоговая оптимизация с учетом международных соглашений',
                  'Защита от штрафов и налоговых рисков через превентивный аудит',
                  'Юридическое сопровождение сделок и контрактов',
                  'Представительство интересов в государственных органах'
                ]
              },
              {
                icon: 'ri-search-line',
                title: 'Аудит и Контроль',
                items: [
                  'Налоговый аудит с привлечением лицензированных YMM',
                  'Бухгалтерский аудит и финансовая отчетность по МСФО',
                  'Выявление рисков и разработка стратегий их минимизации',
                  'Подготовка к налоговым проверкам и сопровождение инспекций'
                ]
              },
              {
                icon: 'ri-settings-3-line',
                title: 'Полный менеджмент',
                items: [
                  'Управление компанией «под ключ» — от бухгалтерии до HR',
                  'Финансовое планирование и бюджетирование',
                  'Управление денежными потоками и оптимизация расходов',
                  'Регулярная отчетность и аналитика для собственников'
                ]
              }
            ].map((item, index) => (
              <div key={index} className="relative pl-32 mb-16 last:mb-0">
                <div className="absolute left-0 w-24 h-24 rounded-full bg-white border-4 border-[#D4AF37] flex items-center justify-center">
                  <i className={`${item.icon} text-4xl text-[#D4AF37]`}></i>
                </div>
                <div className="bg-white rounded-[40px] p-12 shadow-[0_20px_60px_rgba(10,22,40,0.08)] hover:shadow-[0_30px_80px_rgba(10,22,40,0.12)] transition-all hover:-translate-y-2">
                  <h3 className="text-3xl font-semibold text-[#0A1628] mb-6">{item.title}</h3>
                  <ul className="space-y-4">
                    {item.items.map((text, i) => (
                      <li key={i} className="flex items-start gap-3 text-gray-600 font-light leading-relaxed">
                        <i className="ri-check-line text-[#D4AF37] text-xl mt-1 flex-shrink-0"></i>
                        <span>{text}</span>
                      </li>
                    ))}
                  </ul>
                  <button className="mt-8 text-[#D4AF37] font-medium flex items-center gap-2 hover:gap-4 transition-all cursor-pointer">
                    Подробнее
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Spotlight */}
      <section className="py-32 bg-gradient-to-br from-[#1B5E4F] to-[#0A1628] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 bg-[#D4AF37] rounded-full blur-[100px]"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#D4AF37] rounded-full blur-[100px]"></div>
        </div>

        <div className="max-w-[1200px] mx-auto px-8 relative">
          <div className="text-center mb-16">
            <div className="text-6xl mb-4">🔥</div>
            <div className="text-[#D4AF37] text-sm tracking-[4px] uppercase mb-4">EXPERTISE SPOTLIGHT</div>
            <h2 className="text-5xl font-bold text-white leading-tight">
              Почему турецкий бухгалтер —<br />это больше, чем счетовод?
            </h2>
          </div>

          <div className="grid grid-cols-3 gap-8 mb-12">
            {[
              {
                icon: 'ri-shield-check-line',
                title: 'Государственная ответственность',
                content: 'Турецкий бухгалтер (Mali Müşavir) — это не просто сотрудник, а квази-государственный служащий. Он несет <span class="text-[#D4AF37] font-semibold">солидарную ответственность</span> за правильность ваших налоговых отчислений перед государством.'
              },
              {
                icon: 'ri-quill-pen-line',
                title: 'Право подписи',
                content: 'Только сертифицированный финансовый советник <span class="inline-block px-3 py-1 bg-[#D4AF37]/20 rounded-full text-[#D4AF37] font-semibold text-sm">SMMM</span> или присяжный аудитор <span class="inline-block px-3 py-1 bg-[#D4AF37]/20 rounded-full text-[#D4AF37] font-semibold text-sm">YMM</span> имеет право подписи официальных деклараций. Ошибка в подписи стоит бизнеса.'
              },
              {
                icon: 'ri-graduation-cap-line',
                title: 'Высочайшая квалификация',
                content: 'Чтобы получить лицензию, специалист проходит многолетнюю стажировку и сложнейшие государственные экзамены. <span class="text-xl italic text-[#D4AF37] block mt-4">"Уровень докторской степени"</span>'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white/15 backdrop-blur-xl rounded-[32px] p-10 border border-white/20">
                <div className="w-14 h-14 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-3xl text-[#D4AF37]`}></i>
                </div>
                <h3 className="text-2xl font-semibold text-white mb-4">{item.title}</h3>
                <p className="text-white/90 font-light leading-relaxed" dangerouslySetInnerHTML={{ __html: item.content }}></p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button className="px-16 py-6 rounded-full bg-[#D4AF37] text-[#0A1628] font-semibold text-lg whitespace-nowrap hover:shadow-2xl transition-all hover:-translate-y-1 cursor-pointer inline-flex items-center gap-3">
              Наше преимущество: Лицензированные специалисты с правом подписи
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Investment & Scaling */}
      <section className="py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-2 gap-20 items-center mb-32">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20financial%20growth%20charts%20and%20investment%20portfolio%20analytics%2C%20elegant%20desk%20setup%2C%20professional%20business%20environment%2C%20stock%20market%20graphs%2C%20clean%20minimalist%20composition%2C%20premium%20corporate%20photography%2C%20soft%20natural%20lighting%2C%20sophisticated%20atmosphere&width=800&height=600&seq=investment1&orientation=landscape"
                alt="Investment Strategies"
                className="w-full h-[500px] object-cover object-top rounded-[48px] shadow-[0_30px_80px_rgba(10,22,40,0.1)]"
              />
            </div>
            <div>
              <div className="text-[#D4AF37] text-xs tracking-[3px] uppercase mb-4">INVESTMENT STRATEGIES</div>
              <h2 className="text-5xl font-bold text-[#0A1628] mb-8">Персональные портфели</h2>
              <div className="space-y-6 mb-10">
                {[
                  'Индивидуальные инвестиционные стратегии с учетом вашего профиля риска',
                  'Максимизация прибыли в кросс-граничных операциях',
                  'Безопасное управление капиталом через проверенные инструменты',
                  'Диверсификация активов по географиям и классам'
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-8 h-8 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-[#D4AF37]"></i>
                    </div>
                    <p className="text-gray-600 font-light leading-relaxed">{item}</p>
                  </div>
                ))}
              </div>
              <button className="px-10 py-4 rounded-full bg-[#0A1628] text-white font-medium whitespace-nowrap hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                Рассчитать доходность
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-20 items-center">
            <div>
              <div className="text-[#D4AF37] text-xs tracking-[3px] uppercase mb-4">INTERNATIONAL SCALING</div>
              <h2 className="text-5xl font-bold text-[#0A1628] mb-8">Международное масштабирование</h2>
              <p className="text-xl text-gray-600 font-light mb-8 leading-relaxed">
                Юридическая и финансовая архитектура в финансовых центрах мира
              </p>
              <div className="grid grid-cols-2 gap-6">
                {[
                  { region: 'Европа', cities: ['Роттердам', 'Белград', 'Подгорица'], flag: '🇪🇺' },
                  { region: 'Азия', cities: ['Гонконг', 'Сингапур', 'Вьетнам', 'Таиланд'], flag: '🌏' },
                  { region: 'Ближний Восток', cities: ['ОАЭ', 'КСА'], flag: '🕌' },
                  { region: 'США', cities: ['Нью-Йорк', 'Майами'], flag: '🇺🇸' }
                ].map((item, i) => (
                  <div key={i} className="bg-[#F5F7FA] rounded-[24px] p-6">
                    <div className="text-3xl mb-3">{item.flag}</div>
                    <h4 className="text-lg font-semibold text-[#0A1628] mb-3">{item.region}</h4>
                    <ul className="space-y-2">
                      {item.cities.map((city, j) => (
                        <li key={j} className="text-sm text-gray-600 font-light flex items-center gap-2">
                          <div className="w-1 h-1 rounded-full bg-[#D4AF37]"></div>
                          {city}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Stylized%20world%20map%20with%20glowing%20location%20pins%20marking%20major%20financial%20centers%2C%20modern%20digital%20interface%2C%20blue%20and%20gold%20color%20scheme%2C%20abstract%20geographic%20visualization%2C%20premium%20business%20graphics%2C%20clean%20minimalist%20design%2C%20professional%20corporate%20illustration&width=800&height=600&seq=scaling1&orientation=landscape"
                alt="Global Scaling"
                className="w-full h-[500px] object-cover object-top rounded-[48px] shadow-[0_30px_80px_rgba(10,22,40,0.1)]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[#0A1628]">
        <div className="max-w-[1400px] mx-auto px-8 text-center">
          <h2 className="text-5xl font-bold text-white mb-6">Готовы начать?</h2>
          <p className="text-xl text-gray-400 font-light mb-10">
            Получите бесплатную консультацию от наших экспертов
          </p>
          <Link to="/contacts" className="inline-flex items-center gap-3 px-12 py-5 rounded-full bg-[#D4AF37] text-[#0A1628] font-semibold text-lg whitespace-nowrap hover:shadow-2xl transition-all hover:-translate-y-1 cursor-pointer">
            Записаться на консультацию
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
